import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import {
    SWAN_BASE_URL_MAP,
    ScreenClassProvider,
    SwanHead,
    SwanProvider,
    getRootClassNames,
    getSwanJsUrl,
} from '@vp/swan';

interface SwanConfigurationProps {
    children: React.ReactNode;
}

export const SwanConfiguration = ({ children }: SwanConfigurationProps) => {
    const rootClassName = getRootClassNames();

    useEffect(() => {
        if (typeof document === 'undefined') return;

        document.body.className = rootClassName;
        const src = getSwanJsUrl('popover', undefined, SWAN_BASE_URL_MAP.default.cdn);
        if (src) {
            const s = document.createElement('script');
            s.setAttribute('src', src ?? '');
            s.setAttribute('data-swan', 'popover');
            s.async = true;
            document.body.appendChild(s);
        }
    }, [rootClassName]);

    return (
        <HelmetProvider>
            <ScreenClassProvider>
                <SwanProvider swanBaseUrl={SWAN_BASE_URL_MAP.default.cdn}>
                    <SwanHead />
                    {children}
                </SwanProvider>
            </ScreenClassProvider>
        </HelmetProvider>
    );
};
